export var ImportModalView;
(function (ImportModalView) {
    ImportModalView["SELECTION"] = "SELECTION";
    ImportModalView["UPLOAD"] = "UPLOAD";
    ImportModalView["INSTRUCTIONS"] = "INSTRUCTIONS";
    ImportModalView["UPLOADING"] = "UPLOADING";
    ImportModalView["LOADING"] = "LOADING";
    ImportModalView["FILE_LOADED"] = "FILE_LOADED";
    ImportModalView["UPLOAD_ERROR"] = "UPLOAD_ERROR";
    ImportModalView["VALIDATION_RESULT"] = "VALIDATION_RESULT";
    ImportModalView["SUCCESS"] = "SUCCESS";
})(ImportModalView || (ImportModalView = {}));
export var UploadErrorType;
(function (UploadErrorType) {
    UploadErrorType["SYSTEMIC"] = "SYSTEMIC";
    UploadErrorType["FILE_SIZE"] = "FILE_SIZE";
    UploadErrorType["INVALID_FORMAT"] = "INVALID_FORMAT";
})(UploadErrorType || (UploadErrorType = {}));
export var ImportColumnType;
(function (ImportColumnType) {
    ImportColumnType["VALUE"] = "VALUE";
    ImportColumnType["DAYS"] = "DAYS";
})(ImportColumnType || (ImportColumnType = {}));
export var DiscountColumnType;
(function (DiscountColumnType) {
    DiscountColumnType["PERCENTAGE"] = "PERCENTAGE";
    DiscountColumnType["FIXED"] = "FIXED";
    DiscountColumnType["NONE"] = "NONE";
})(DiscountColumnType || (DiscountColumnType = {}));
export const ACCEPTED_FILE_TYPES = ['xlsx', 'xls'];
export const MAX_FILE_SIZE_KB = 5120;
export const TEMPLATE_FILE_NAME = 'modelo_importacao_beneficiarios';
